import get from 'lodash.get'
import isEmpty from 'lodash.isempty'

import {
  fetchActionsCustomerRequestDiscussion,
  fetchDetailsCustomerRequestDiscussion,
  fetchInformationCustomerRequestDiscussion,
  fetchProductReturnsCustomerRequestPlatform,
  sosCustomerRequestDiscussion,
} from '@http/endpoints'

export default {
  namespaced: true,

  state() {
    return {
      actions: {},
      customerRequest: {},
    }
  },
  getters: {
    information(state) {
      return state.customerRequest
    },
    isAllowed(state) {
      return (action, defaultValue = false) =>
        get(state.actions, action, defaultValue)
    },
  },
  mutations: {
    clear(state) {
      state.actions = {}
      state.customerRequest = {}
    },
    closeDetails(state) {
      if (isEmpty(state.customerRequest)) {
        return
      }

      state.customerRequest = {
        ...state.customerRequest,
        detailed: false,
      }
    },
    set(state, { information }) {
      state.customerRequest = information
    },
    setActions(state, { actions }) {
      state.actions = actions
    },
    setDetails(state, { details }) {
      if (isEmpty(state.customerRequest)) {
        return
      }

      state.customerRequest = {
        ...state.customerRequest,
        ...details,
        product: {
          ...state.customerRequest.product,
          ...details.product,
        },
        orderline: {
          ...state.customerRequest.orderline,
          ...details.orderline,
        },
        detailed: true,
      }
    },
    setProductReturns(state, { productReturns }) {
      if (isEmpty(state.customerRequest)) {
        return
      }

      state.customerRequest = {
        ...state.customerRequest,
        productReturns,
      }
    },
    update(state, { updates }) {
      if (isEmpty(state.customerRequest)) {
        return
      }

      state.customerRequest = {
        ...state.customerRequest,
        ...updates,
      }
    },
  },
  actions: {
    clear({ commit }) {
      commit('clear')
    },
    closeDetails({ commit }) {
      commit('closeDetails')
    },
    async fetch({ commit, dispatch }, { customerRequestId }) {
      const { payload: information } = await dispatch(
        'http/request',
        {
          request: fetchInformationCustomerRequestDiscussion,
          pathParams: { customerRequestId },
        },
        { root: true },
      )

      commit('set', { information })
    },
    async fetchActions({ commit, dispatch }, { customerRequestId }) {
      const { payload: actions } = await dispatch(
        'http/request',
        {
          request: fetchActionsCustomerRequestDiscussion,
          pathParams: { customerRequestId },
        },
        { root: true },
      )

      commit('setActions', { actions })
    },
    async fetchDetails({ commit, dispatch }, { customerRequestId }) {
      const [{ payload: details }, { payload: productReturns }] =
        await Promise.all([
          dispatch(
            'http/request',
            {
              request: fetchDetailsCustomerRequestDiscussion,
              pathParams: { customerRequestId },
            },
            { root: true },
          ),
          dispatch(
            'http/request',
            {
              request: fetchProductReturnsCustomerRequestPlatform,
              pathParams: { customerRequestId },
            },
            { root: true },
          ),
        ])

      commit('setDetails', { details })
      commit('setProductReturns', { productReturns })
    },
    async sos({ dispatch }, { customerRequestId }) {
      const { payload } = await dispatch(
        'http/request',
        {
          request: sosCustomerRequestDiscussion,
          pathParams: { customerRequestId },
        },
        { root: true },
      )

      if (!isEmpty(payload.message)) {
        dispatch(
          'customerRequestDiscussion/discussion/addMessage',
          {
            message: payload.message,
          },
          { root: true },
        )
      }
    },
    update({ commit }, { customerRequestId, updates }) {
      commit('update', { customerRequestId, updates })
    },
  },
}
